export default "/images/056ace5c0db03a85474490a3355930e2.avif";